declare let window: OldUIContext.TenForceWindow

const Labels = window?.Language?.Labels ?? {}
const Exceptions = window?.Language?.Exceptions ?? {}
const BlankSlate = window?.Language?.BlankSlate ?? {}
const UserMessages = window?.Language?.UserMessages ?? {}
const DateElements = window?.Language?.DateElements ?? {}
const Help = window?.Language?.Help ?? {}

export { Labels, Exceptions, BlankSlate, UserMessages, DateElements, Help }
